import { UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Anlagenkennlinie } from '../../../domain/model/anlagenkennlinie.model';
import { ControlConfig } from '../form-config.model';
import { WindInformationen } from '../../../domain/model/wind-informationen.model';

export class AnlagenkennlinienValidator {

    static readonly MIN_FILLED_VALUES = 15;

    static validate(isAnlagenkennlinieRequired: () => boolean): ValidatorFn {
        return (formGroup: UntypedFormGroup): ValidationErrors | null => {
            const controls = formGroup.controls as ControlConfig<Anlagenkennlinie>;

            if (!isAnlagenkennlinieRequired()) {
                return null;
            }

            let amountOfValidFields = Object.values(controls).filter(value => value.valid && !!value.value).length;

            return amountOfValidFields < AnlagenkennlinienValidator.MIN_FILLED_VALUES ? { min: true } : null;
        };
    }

    public static required(isAnlagenkennlinieRequired: () => boolean): ValidatorFn {
        return (formGroup: UntypedFormGroup): ValidationErrors | null => {
            const controls = formGroup.controls as ControlConfig<WindInformationen>;
            return AnlagenkennlinienValidator.validate(isAnlagenkennlinieRequired)(controls.anlagenkennlinie);
        };
    }
}
